import * as React from 'react'
import { Search } from 'lucide-react'

import { cn } from '@/lib/utils'

// Search field for filter bars. Same 34px height as MultiSelectFilter and the
// compact Select triggers, so a row of filters lines up. Width via className.
export type SearchInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(({ className, ...props }, ref) => (
  <div className={cn('relative w-[220px]', className)}>
    <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" />
    <input
      ref={ref}
      type="search"
      className="h-[34px] w-full rounded-md border border-input bg-white pl-8 pr-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/15 [&::-webkit-search-cancel-button]:hidden"
      {...props}
    />
  </div>
))
SearchInput.displayName = 'SearchInput'

export { SearchInput }
